import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { REGEX } from '../constants/regex.constants';

export class CustomValidators {
  static name(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;

      if (!value) {
        return { required: true };
      }

      if (value.length < 2) {
        return { minLength: { min: 2, actualLength: value.length } };
      }

      if (value.length > 30) {
        return { maxLength: { max: 30, actualLength: value.length } };
      }

      if (!REGEX.name.test(value)) {
        return { pattern: true };
      }

      return null;
    };
  }

  static email(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;

      if (!value) {
        return { required: true };
      }

      if (value !== value.trim()) {
        return { pattern: true };
      }

      if (!REGEX.email.test(value)) {
        return { pattern: true };
      }

      return null;
    };
  }

  static password(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;

      if (!value) {
        return { required: true };
      }

      if (value.length < 8) {
        return { minLength: { min: 8, actualLength: value.length } };
      }

      if (value.length > 20) {
        return { maxLength: { max: 20, actualLength: value.length } };
      }

      if (REGEX.space.test(value)) {
        return { noSpaces: true };
      }

      if (!REGEX.password.test(value)) {
        return { pattern: true };
      }

      return null;
    };
  }

  static confirmPassword(passwordControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.parent) {
        return null;
      }

      const password = control.parent.get(passwordControlName);
      const confirmPassword = control;

      if (password && confirmPassword.value !== password.value) {
        return { missMatch: true };
      }

      return null;
    };
  }
}
